var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "xr-create",
    {
      attrs: { loading: _vm.loading, title: _vm.title },
      on: { close: _vm.close, save: _vm.saveClick },
    },
    [
      _c(
        "create-sections",
        { attrs: { title: "基本信息" } },
        [
          _c(
            "el-form",
            {
              ref: "crmForm",
              staticClass: "wk-form",
              attrs: {
                model: _vm.fieldForm,
                rules: _vm.fieldRules,
                "field-from": _vm.fieldForm,
                "validate-on-rule-change": false,
                "label-position": "top",
              },
            },
            _vm._l(_vm.fieldList, function (children, index) {
              return _c("wk-form-items", {
                key: index,
                attrs: { "field-from": _vm.fieldForm, "field-list": children },
                on: { change: _vm.formChange },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function ({ data }) {
                        return [
                          data && data.form_type == "map_address"
                            ? _c("xh-customer-address", {
                                attrs: { value: _vm.fieldForm[data.field] },
                                on: {
                                  "value-change": function ($event) {
                                    return _vm.otherChange($event, data)
                                  },
                                },
                              })
                            : _vm._e(),
                        ]
                      },
                    },
                  ],
                  null,
                  true
                ),
              })
            }),
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.action.type == "save" && _vm.contactsSaveAuth
        ? _c(
            "el-button",
            {
              staticClass: "handle-button",
              attrs: { slot: "footer", type: "primary" },
              on: {
                click: function ($event) {
                  return _vm.debouncedSaveField(true)
                },
              },
              slot: "footer",
            },
            [_vm._v("保存并新建联系人")]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.contactsCreateShow
        ? _c("contacts-create", {
            attrs: { action: _vm.contactsCreateAction },
            on: { close: _vm.close, "save-success": _vm.close },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }